<template>
<!-- 添加系统保司 -->
  <div class='content main-container'>
    <!-- <div class="titleBox">
      <h1>添加系统保司</h1>
      <p>选择系统已存在的保司添加在保司管理中</p>
    </div> -->
    <div class="search-box min ">
      <div class="input-item">
        <span class="label">保险公司名称</span>
        <Input v-model="formList.companyName" placeholder="请输入" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchList">查询</Button>
      </div>
    </div>
    <div class="toolbox clearfix">
      <div class="add-btn">
        <Button class="addbtn" type="primary" ghost @click="addCompany">+ 确认添加</Button>
        <div class="select-info">已选择<span style="color:#236DFF;">{{selected.length}}</span>项</div>
      </div>
      <div class="backbtn"><Button class="back-btn" type="primary" @click="$router.go(-1)">返回</Button></div>
    </div>
    <div class="tableBox">
      <loading :isShow="loading" />
      <!-- <Table :columns="tableData" class="table-style" :data="dataInfo" @on-selection-change="selectChange"></Table> -->
      <Table :columns="tableData" class="table-style" :data="dataInfo" @on-select-all-cancel="handleCancelSelectAll" @on-select-all="handleSelectAll" @on-select="handleSelect" @on-select-cancel="handleCancel"></Table>
    </div>
    <div class="pageBox">
      <Page :total="allData.total" :current="allData.current" :page-size="allData.size" show-total @on-change="pageChange" style="text-align: center" />
    </div>
    <Modal class-name="success-modal" v-model="successModal" :closable="false">
      <p slot="header" style="text-align:left">
        <Icon style="color:#ff9900;font-size: 16px;" type="ios-help-circle-outline" />
        <span>信息</span>
      </p>
      <div style="text-align:center">
        <Icon style="color:#19be6b;font-size: 50px;" type="ios-checkmark-circle-outline" />
        <div>添加成功</div>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long @click="backUp">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  data: () => ({
    pageNo: 1,
    pageSize: 20,
    allData: [], // 所有数据
    formList: {
      companyName: '',
    },
    tableData: [
      {
        type: 'selection',
        width: 60,
        align: 'center',
      },
      {
        title: '序号',
        type: 'index',
        align: 'center',
        width: '80px;',
      },
      {
        title: '保司code',
        key: 'code',
        align: 'center',
        width:150
      },
      {
        title: '保险公司简称',
        key: 'name',
        align: 'center',
      },
      {
        title: '保险公司全称',
        key: 'fullName',
        align: 'center',
        minWidth:250,
        ellipsis: true,
        tooltip: true
      },
      {
        title: '公司logo',
        width: '200px',
        key: 'ico',
        align: 'center',
        render: (h, params) => {
          return h('div', [
            h('img', {
              attrs: {
                src: params.row.ico,
                style: 'width:90px;max-height:40px;',
              },
            }),
          ])
        },
      },
    ],
    dataInfo: [],
    companyIds: [], // 选中保司的id
    selected: [], // 选中的保司
    successModal: false,
    loading: false,
  }),
  created() {
    this.getCompanyList()
    sessionStorage.removeItem('selectedProduct')
  },
  methods: {
    // 添加公司
    addCompany() {
      if (this.selected.length == 0) {
        this.$Message.warning('未选择保司')
        return
      }
      this.selected.map((item, index) => {
        this.companyIds.push(item.id)
      })
      this.$http({
        url: '/buz/merchantCompanyJoin/add',
        type: 'post',
        data: {
          companyIds: this.companyIds,
        },
      }).then((res) => {
        window.scrollTo(0, 0)
        if (res.httpCode == 1) {
          this.successModal = true
        } else {
          this.$Message.error('添加失败')
        }
      })
    },
    pageChange(index) {
      this.pageNo = index
      this.getCompanyList()
    },
    getCompanyList() {
      this.loading = true
      let params = {
        name: this.formList.companyName, //名称
        pageSize: this.pageSize,
        pageNo: this.pageNo,
      }
      for (var key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      this.$http({
        url: '/buz/insuranceCompany/cloud/list',
        type: 'post',
        data: params,
      })
        .then((res) => {
          this.loading = false
          window.scrollTo(0, 0)
          this.dataInfo = res.data
          this.allData = res
          this.updateChecked()
        })
        .catch((e) => {
          this.loading = false
        })
    },
    // 更新选中状态
    updateChecked() {
      let selected = JSON.parse(sessionStorage.getItem('selectedProduct'))
      if (selected && selected.length > 0) {
        this.dataInfo.map((item) => {
          item._checked = false
          selected.map((select) => {
            if (select.id == item.id) {
              item._checked = true
            }
          })
        })
        this.selected = [...selected]
      }
    },
    // 取消全选
    handleCancelSelectAll(selection){
      //从已选项中移除当页数据
      this.selected = _.differenceBy(this.selected, this.dataInfo, "id");
      sessionStorage.setItem('selectedProduct',JSON.stringify(this.selected))
    },
    // 全选
    handleSelectAll(selection){
      //数组合并，有可能用户先选择了某几项，已经被我们push进去，因此数组合并需要去重一下
      this.selected = _.uniqBy(this.selected.concat(selection), "id");
      sessionStorage.setItem('selectedProduct',JSON.stringify(this.selected))
    },
    //选中单项
    handleSelect(selection, row){
      //添加到已选项
      this.selected.push(row);
      sessionStorage.setItem('selectedProduct',JSON.stringify(this.selected))
    },
    //取消选中单项
    handleCancel(selection, row){
      //从已选项中去除取消项
      this.selected = this.selected.filter(item=>{
        return item.id != row.id;
      })
      _.remove(this.selected, n => {
        return n.id === row.id;
      });
      sessionStorage.setItem('selectedProduct',JSON.stringify(this.selected))
    },
    //选中项
    // selectChange(selection) {
    //   this.selected = selection
    // },
    // 搜索
    searchList() {
      this.getCompanyList()
    },
    backUp() {
      let self = this
      this.successModal = false
      setTimeout(function () {
        self.$router.push('/offline/insuranceManage')
      }, 50)
    },
  },
  filters: {
    filterType(val) {
      if (val == '1') {
        return '寿险'
      } else if (val == '2') {
        return '产险'
      }
    },
  },
}
</script>
<style lang='scss' scoped>
@import './addInsurance';
@import './common';
</style>
<style lang="scss">
.success-modal {
  .ivu-modal-header {
    font-size: 14px;
    color: #17233d;
  }
  .ivu-modal-body {
    font-size: 14px;
    color: #515a6e;
  }
}
.table-style {
  // .ivu-table-header tr {
  //     color: #fff;    //字体颜色
  //     font-weight: normal;       //字体粗细
  //     background-color: #236DFF;    //背景颜色
  //     border: none;    //边框有无
  //     border-bottom: 1px solid #E9E9E9;;     //边框粗细及样式颜色
  // }
  // .ivu-table td, .ivu-table th{
  //     border-right:none;
  //     border-left: none;
  // }
}
</style>